import DirectionsCarIcon from '@mui/icons-material/DirectionsCarOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import { ReservationDetailPage } from '../../components/ReservationDetailPage';
import { RENTCAR_CAPS } from '../../components/reservation/capabilities';
import RentCarFlowPage from './pages/RentCarFlowPage';
import RentCarReservationsPage from './pages/RentCarReservationsPage';

/** Clicking a PNR/ticket number in "Rezervasyon Listesi" navigates to
 *  `rent-car/reservations/:identifier` — the shared `ReservationDetailPage` (see
 *  ../../components/ReservationDetailPage.tsx), re-fetched fresh via `Entry/Find`.
 *  `RENTCAR_CAPS.cancel = 'rentcar'` wires İptal Et to `RentCar/CancelOrder`
 *  (keyed off the row's `shoppingCartId`). */
export const rentCarModule: ModuleDefinition = {
  routes: [
    { path: 'rent-car', element: <RentCarFlowPage /> },
    { path: 'rent-car/reservations', element: <RentCarReservationsPage /> },
    {
      path: 'rent-car/reservations/:identifier',
      element: <ReservationDetailPage capabilities={RENTCAR_CAPS} />,
    },
  ],
  menuItems: [
    {
      label: 'Arama',
      path: 'rent-car',
      icon: <DirectionsCarIcon />,
      group: 'Araç Kiralama',
      groupIcon: <DirectionsCarIcon />,
    },
    {
      label: 'Rezervasyon Listesi',
      path: 'rent-car/reservations',
      icon: <ListAltOutlinedIcon />,
      group: 'Araç Kiralama',
    },
  ],
};
